/** The record key convention shared with v1 and the database.
 *
 * Postgres:  rec_norm(t)  = lower(trim(t))
 * v1 client: _recNorm(s)  = String(s || "").trim().toLowerCase()
 * v2:        natKey(s)    — MUST match both, byte for byte, forever.
 *
 * Every cross-app record (lead edits, tasks) is addressed by this key; a
 * divergence here silently forks a record into two. The parity test in
 * tests/natkey.test.ts pins the exact semantics.
 */
export function natKey(s: unknown): string {
  return String(s ?? "").trim().toLowerCase();
}

/** v1 task natural key: title|deal|stage|auto("1"/"0") — mirrors both the
 * crm_state decompose trigger and rec_apply_ops' tasks section. */
export function taskKey(title: string, deal = "", stage = "", auto = false): string {
  return `${title}|${deal}|${stage}|${auto ? "1" : "0"}`;
}
